import _ from 'lodash'
import { isTopicWithQuestions } from '../../client/lib/legacy/legacyEngine'

export function simulateDemoUser (activity, demoString) {
  activity.studentData.user_id = 'demo_user_' + demoString
  activity.config.itemId = 'demo_assignment_' + demoString

  return activity
}

export function simulateDemoProgress (activity, simulateData = 0) {
  activity.studentData.activity_questions_received = activity.questions.length

  // get indices of all NON-ORPHAN topics
  const topicIdsWithQuestions = _.reduce(activity.topics, (acc, topic) => {
    if (isTopicWithQuestions(topic, activity.questions)) {
      acc.push(topic.topicId)
    }
    return acc
  }, [])

  // Case 2, First Quiz Completed
  if (simulateData === 2) {
    _.each(activity.topics, (topic, i) => {
      if (topic.totalPointsAvailable === 0 && topicIdsWithQuestions.includes(topic.topicId)) {
        topic.totalPointsAvailable = Math.floor(activity.score.scoreTarget / topicIdsWithQuestions.length)
      }

      // Make first 2 NON-ORPHAN topics have very low scores to trigger CYU
      if (topic.topicId === topicIdsWithQuestions[0]) {
        topic.totalPointsEarned = Math.floor(topic.totalPointsAvailable * 0.57)
      } else if (topic.topicId === topicIdsWithQuestions[1]) {
        topic.totalPointsEarned = Math.floor(topic.totalPointsAvailable * 0.68)
      } else if (topicIdsWithQuestions.includes(topic.topicId)) {
        // Subsequent NON-ORPHAN topics, if any, will have a fixed score of 82%
        topic.totalPointsEarned = Math.floor(topic.totalPointsAvailable * 0.82)
      }
    })
    activity.score.activityScore = activity.score.scoreTarget
  } else if (simulateData === 3) {
    activity.studentData.final_questions_received = activity.questions.length

    _.each(activity.topics, (topic, i) => {
      // Build first attempt again exactly as before, this time in activity.finalScore.topics
      const ft = activity.finalScore.topics[i]

      if (ft.totalPointsAvailable === 0 && topicIdsWithQuestions.includes(topic.topicId)) {
        ft.totalPointsAvailable = Math.floor(activity.finalScore.scoreTarget / topicIdsWithQuestions.length)
      }

      if (ft.topicId === topicIdsWithQuestions[0]) {
        ft.totalPointsEarned = Math.floor(ft.totalPointsAvailable * 0.57)
      } else if (ft.topicId === topicIdsWithQuestions[1]) {
        ft.totalPointsEarned = Math.floor(ft.totalPointsAvailable * 0.68)
      } else if (topicIdsWithQuestions.includes(topic.topicId)) {
        ft.totalPointsEarned = Math.floor(ft.totalPointsAvailable * 0.82)
      }

      // Build Retake
      // First topic will have a slightly higher score than before, but still triggers CYU
      // Subsequent topics will have a fixed score of 91%
      if (topic.totalPointsAvailable === 0 && topicIdsWithQuestions.includes(topic.topicId)) {
        topic.totalPointsAvailable = Math.floor(activity.score.scoreTarget / topicIdsWithQuestions.length)
      }

      if (topic.topicId === topicIdsWithQuestions[0]) {
        topic.totalPointsEarned = Math.floor(topic.totalPointsAvailable * 0.79)
      } else if (topicIdsWithQuestions.includes(topic.topicId)) {
        topic.totalPointsEarned = Math.floor(topic.totalPointsAvailable)
      }
    })
    activity.score.activityScore = activity.score.scoreTarget
    activity.finalScore.activityScore = activity.finalScore.scoreTarget
  } else if (simulateData === 4) { // set all topics to red
    activity.studentData.final_questions_received = activity.questions.length

    _.each(activity.topics, (topic, i) => {
      if (topicIdsWithQuestions.includes(topic.topicId)) {
        if (topic.totalPointsAvailable === 0) {
          topic.totalPointsAvailable = Math.floor(activity.score.scoreTarget / topicIdsWithQuestions.length)
        }
        topic.totalPointsEarned = Math.floor(topic.totalPointsAvailable * 0.75)
        activity.score.activityScore += topic.totalPointsAvailable - topic.totalPointsEarned
      }

      activity.score.activityScore += topic.totalPointsEarned
    })
  }

  activity.score.activityGrade = activity.score.activityScore >= activity.score.scoreTarget ? 1 : 0

  if (activity.finalScore && activity.finalScore.activityScore >= activity.finalScore.scoreTarget) {
    activity.finalScore.activityGrade = 100
  }

  return activity
}

// function randNum (min, max) {
//   return Math.floor(Math.random() * (max - min) + min)
// }
